import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mt-4 h-100 w-100 right-to-work-check" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header bg-primary text-white" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table table-sm mb-4" }
const _hoisted_7 = { class: "rtw-step mb-3" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-2 align-items-end" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_11 = {
  key: 0,
  class: "text-muted d-block mt-2"
}
const _hoisted_12 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_17 = {
  key: 2,
  class: "rtw-result-text"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "rtw-step" }
const _hoisted_20 = { class: "d-flex flex-wrap gap-2 align-items-end" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, "Right to Work - " + _toDisplayString($props.officerName || $data.current.officerName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("th", null, "Status", -1)),
              _createElementVNode("td", null, _toDisplayString($data.current.status || 'Never checked'), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[9] || (_cache[9] = _createElementVNode("th", null, "Valid until", -1)),
              _createElementVNode("td", null, _toDisplayString($options.formatDate($data.current.validUntil) || '-'), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[10] || (_cache[10] = _createElementVNode("th", null, "Last checked", -1)),
              _createElementVNode("td", null, _toDisplayString($options.formatDateTime($data.current.lastCheckedAt) || '-'), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "rtw-step-title" }, "1. Check on the Home Office site", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label mb-0" }, "Share code", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.shareCode) = $event)),
                class: "form-control form-control-sm rtw-control",
                placeholder: "e.g. W4B 7XR 2KP",
                maxlength: "20"
              }, null, 512), [
                [_vModelText, $data.shareCode]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label mb-0" }, "Date of birth", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.dateOfBirth) = $event)),
                class: "form-control form-control-sm rtw-control"
              }, null, 512), [
                [_vModelText, $data.dateOfBirth]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary rtw-button",
              disabled: $data.checking || !$data.shareCode.trim() || !$data.dateOfBirth,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.runCheck && $options.runCheck(...args)))
            }, [
              ($data.checking)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString($data.checking ? 'Checking… (can take up to a minute)' : 'Run check'), 1)
            ], 8, _hoisted_9)
          ]),
          ($data.current && $data.current.shareCodeUpdatedAt)
            ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Saved share code, last updated " + _toDisplayString($options.formatDate($data.current.shareCodeUpdatedAt)), 1))
            : _createCommentVNode("", true)
        ]),
        ($data.checkResult)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              ($data.checkResult.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[14] || (_cache[14] = _createTextVNode(" Result screenshot saved to the officer's documents as ", -1)),
                    _createElementVNode("strong", null, _toDisplayString($data.checkResult.documentName), 1),
                    _cache[15] || (_cache[15] = _createTextVNode(". Read the status and expiry below and record them in step 2. ", -1)),
                    ($data.checkResult.dateOfBirthSaved)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Date of birth saved to the officer's record."))
                      : _createCommentVNode("", true),
                    ($data.checkResult.shareCodeSaved)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Share code saved to the officer's record."))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($data.checkResult.errorMessage), 1)),
              ($data.checkResult.resultText)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_17, _toDisplayString($data.checkResult.resultText), 1))
                : _createCommentVNode("", true),
              ($data.checkResult.screenshotBase64)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    src: `data:image/jpeg;base64,${$data.checkResult.screenshotBase64}`,
                    class: "img-fluid border",
                    alt: "Home Office page screenshot"
                  }, null, 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _cache[20] || (_cache[20] = _createElementVNode("h5", { class: "rtw-step-title" }, "2. Record the result", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label mb-0" }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.status) = $event)),
                class: "form-select form-select-sm rtw-control"
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "Select status", -1),
                _createElementVNode("option", { value: "Valid" }, "Valid", -1),
                _createElementVNode("option", { value: "Expired" }, "Expired", -1)
              ]))], 512), [
                [_vModelSelect, $data.status]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                class: "form-label mb-0",
                title: "Leave empty if the right to work has no end date"
              }, "Valid until", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.validUntil) = $event)),
                class: "form-control form-control-sm rtw-control"
              }, null, 512), [
                [_vModelText, $data.validUntil]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label mb-0" }, "Last checked", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "datetime-local",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.lastCheckedAt) = $event)),
                class: "form-control form-control-sm rtw-control"
              }, null, 512), [
                [_vModelText, $data.lastCheckedAt]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-success rtw-button",
              disabled: $data.saving || !$data.status || !$data.lastCheckedAt,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.saveStatus && $options.saveStatus(...args)))
            }, "Save", 8, _hoisted_21)
          ])
        ]),
        ($data.message)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["alert mt-3", $data.messageType]),
              role: "alert"
            }, _toDisplayString($data.message), 3))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary mt-3",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
        }, "Close")
      ])
    ])
  ]))
}